import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

import { ShadedBackgroundColorProp } from '~app/components/EndpageImage';

type StyleProps = {
  shadedBackgroundColor: ShadedBackgroundColorProp | undefined;
};

const useStyles = createUseStyles(
  ({ brandColors: { background }, breakpoints, type: { fontSize, fontWeight } }: CmsWrenchTheme) => {
    const mediaQueryMinScreenLG = `@media (min-width: ${breakpoints.lg}px)`;
    const mediaQueryMinScreenMD = `@media (min-width: ${breakpoints.md}px)`;

    return {
      container: ({ shadedBackgroundColor }: StyleProps) => ({
        background: shadedBackgroundColor ? background[shadedBackgroundColor] : undefined,
      }),
      headingText: {
        fontWeight: fontWeight.medium,
        [mediaQueryMinScreenLG]: {
          fontSize: fontSize.pageTitle,
        },
      },
      logoWithTextContainer: {
        display: 'none',
        [mediaQueryMinScreenMD]: {
          display: 'block',
        },
      },
      logoGoldieContainer: {
        display: 'block',
        [mediaQueryMinScreenMD]: {
          display: 'none',
        },
      },
      logoWithText: {
        height: 32,
        display: 'none',
        [mediaQueryMinScreenMD]: {
          height: 39,
          display: 'block',
        },
      },
      logoGoldie: {
        fontSize: 52,
        marginTop: '-1px',
        display: 'flex',
        '& svg path': {
          color: '#00bf6f !important',
          fill: '#00bf6f !important',
        },
        [mediaQueryMinScreenMD]: {
          fontSize: 59,
          display: 'none',
        },
      },
      bannerLogoGoldie: {
        fontSize: 45,
        alignSelf: 'center',
        [mediaQueryMinScreenMD]: {
          fontSize: 40,
          alignSelf: 'inherit',
        },
      },
      bannerText: {
        '& div': {
          textAlign: 'center',
          padding: 8,
        },
        [mediaQueryMinScreenMD]: {
          '& div': {
            padding: 0,
            textAlign: 'left',
          },
        },
      },
      logo: {
        height: 22,
        [mediaQueryMinScreenMD]: {
          height: 29,
        },
        width: '100%',
      },
      negativeMargin: {
        marginTop: '-1px',
      },
      desktopView: {
        marginTop: '-1px',
        display: 'none',
        [mediaQueryMinScreenMD]: {
          display: 'block',
        },
      },
      mobileView: {
        width: '300px',
        display: 'block',
        [mediaQueryMinScreenMD]: {
          display: 'none',
        },
      },
      subheadingText: {
        [mediaQueryMinScreenMD]: {
          fontSize: (fontSize.body as number) * 1.125,
        },
      },
      buttonColor: {
        '&span': '#f5f5f5',
      },
      bannerWrapper: {
        backgroundColor: '#00bf6f',
      },
      bannerContainer: {
        width: '100%',
        [mediaQueryMinScreenMD]: {
          width: 980,
        },
      },
      bannerHeadingText: {
        fontWeight: fontWeight.medium,
      },
      '@global': {
        '& div span a': {
          color: '#00898b',
        },
        '& a': {
          '& svg path:last-child': {
            color: '#008323',
            fill: '#008323',
          },
          '& svg': {
            '& g': {
              color: '#404040',
              fill: '#404040',
              '& path:last-child': {
                color: '#404040',
                fill: '#404040',
              },
            },
          },
        },
      },
    };
  }
);

export default useStyles;
